// Return after sign-in (LNK-1, Specs/Meeting Links + Return After Sign-In — Spec). A signed-out
// visit to any app page goes to /login?next=<that page>; after signing in, the login screens send
// you to `next` — but only if it's a page inside Launch OS (a link must never use our login
// screen to bounce someone to another website).

const SIGN_IN_PATHS = ["/login", "/authLogin", "/authVerify"];

const isSafeAppPath = (next: string) =>
  next.startsWith("/") &&
  !next.startsWith("//") &&
  !next.startsWith("/\\") &&
  !SIGN_IN_PATHS.some((p) => next === p || next.startsWith(`${p}?`) || next.startsWith(`${p}/`) || next.startsWith(`${p}#`));

// where to go after sign-in: the remembered page if it's safe, else the screen's normal landing page
export const postLoginDestination = (next: string | null | undefined, landing: string): string =>
  next && isSafeAppPath(next) ? next : landing;

// the login address for a signed-out visit to pathname + search + hash
export const loginPathFor = (pathname: string, search = "", hash = ""): string => {
  const here = `${pathname}${search}${hash}`;
  return here === "/" || !isSafeAppPath(here) ? "/login" : `/login?next=${encodeURIComponent(here)}`;
};

// the remembered page on the current login screen's address
export const nextFromLocation = (search: string = window.location.search): string | null =>
  new URLSearchParams(search).get("next");

// the screen a person lands on after sign-in, by what they can use
export const landingFor = (permissions: string[] | undefined): string => {
  if (permissions?.includes("agents")) return "/agents/home"; // Agents users land on the Agents home (AMB-309)
  if (permissions?.includes("f$-internal")) return "/order-forms";
  if (permissions?.includes("scroll")) return "/crm/contacts";
  if (permissions?.includes("concierge")) return "/concierge";
  return "/pages";
};
